import React from 'react'
import Helmet from 'react-helmet'
import { mapProps } from 'recompose'

import {
  getSiteTitle
} from 'utils/selectors'

const About = ({ siteTitle }) => (
  <div className='max-width-2 mx-auto px2'>
    
    <Helmet title={`About | ${siteTitle}`} />
    
    <div className='sm-flex items-center'>
      <div className='mr2 sm-col-4 max-width-1'>
        <img 
          src={require('images/xav.jpg')} 
          className='fit block'
        />
      </div>
      <p className='sm-col-8'>
        Mono2Ski is run by professional ski instructor Xavier Raguin—who has been instructing since 2001. Xavier has a vast knowledge of the main ski areas in the French Alps, including Espacé Killy, Paradiski and Les Trois Vallees.
      </p>
    </div>

    <blockquote className='h3 italic gray line-height-3'>
      <p>I created Mono2ski in order to provide my professional experience to skiers and snowboarders of all skill levels. I strive to offer the technical and analytical expertise of a private coach while ensuring that you enjoy every moment of your day, whether on marked runs or off-piste, so that you can improve your skill level under the best possible conditions.</p>
    </blockquote>
    
    <div className=''>
      <img 
        src={require('images/xav-ski.jpg')} 
        className='fit block'
      />
    </div>
    
    <p>
      Xavier has a passion for challenging off-piste and technical piste skiing. As well as being a fully qualified ski instructor, he is also a fully qualified snowboard instructor and enjoys the teaching element greatly.
    </p>
  </div>
)

const hoc = mapProps(({ data }) => ({
  siteTitle: getSiteTitle(data),
}))

export default hoc(About)

export const pageQuery = graphql`
  query AboutPageQuery {
    site {
      siteMetadata {
        title
        author
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/about.js